import(/* webpackMode: "eager" */ "/codebuild/output/src12652756/src/fleming-dashboard/src/app/layout.tsx")